import { Button, Modal } from '@alphonsocode/kallos';
import React, { useEffect, useRef, useState } from 'react';
import FilterRow from './filterRow';
import { MdAddCircleOutline } from 'react-icons/md';
import Badges from '../Badge';
import { nanoid } from '@reduxjs/toolkit';

export default function ModalBody({
  rows,
  setRows,
  filtersState,
  setFiltersState,
  filters,
  isFetchingFilters,
}) {
  const handleAddFilter = () => {
    const newRow = nanoid();
    setRows([...rows, newRow]);
    setFiltersState([...filtersState, { filter: null, value: null }]);
  };

  const handleFilterChange = (rowId, filter, value) => {
    const index = rows.findIndex(id => id === rowId);
    if (index === -1) return;

    const updatedFiltersState = [...filtersState];
    updatedFiltersState[index] = { filter, value };
    setFiltersState(updatedFiltersState);
  };

  const resetFilters = () => {
    setRows([nanoid()]);
    setFiltersState([]);
  };

  const handleBadgeClose = indexToRemove => {
    const updated = [...filtersState];
    const nonNullFilters = filtersState.filter(item => item.filter);

    const toRemove = nonNullFilters[indexToRemove];

    const idx = filtersState.findIndex(
      item => item.filter?.label === toRemove.filter.label,
    );

    if (idx !== -1) {
      updated.splice(idx, 1);
      const updatedRows = rows.filter((_, i) => i !== idx);
      setRows(updatedRows);
      setFiltersState(updated);
    }
  };

  useEffect(() => {
    const hasValidFilters = filtersState.some(item => item.filter);
    if (!hasValidFilters && filtersState.length === 0 && rows.length === 0) {
      setRows([nanoid()]);
      setFiltersState([{ filter: null, value: null }]);
    }
  }, [filtersState, rows, setFiltersState, setRows]);

  const isAddFilterDisabled = filtersState.some(row => row.filter === null);
  const availableFilters = filters.filter(filter => {
    return (
      filter.key !== 'testTag' &&
      filter.key !== 'testId' &&
      !filtersState.some(state => state.filter?.label === filter.label)
    );
  });
  const [isOpen, setIsOpen] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Scroll to the bottom whenever rows change
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [isOpen]);
  return (
    // @ts-ignore - Production hotfix for kallos Modal.Body typing
    <Modal.Body>
      <div
        ref={scrollRef}
        style={{
          minHeight: '50vh',
          maxHeight: '80vh',
          overflowY: 'auto',
          padding: '10px',
        }}
      >
        <div className="filterRows">
          {rows.map((rowId, idx) => (
            <FilterRow
              key={rowId}
              rowId={rowId}
              filters={filters}
              availableFilters={availableFilters}
              isFetchingFilters={isFetchingFilters}
              onFilterChange={handleFilterChange}
              selectedFilter={filtersState[idx]?.filter}
              selectedValue={filtersState[idx]?.value}
              setIsOpen={setIsOpen}
            />
          ))}
        </div>
        <div className="text-left mt-3">
          <Button
            colorVariant="deepGreen"
            variant="borderless"
            onClick={handleAddFilter}
            disabled={isAddFilterDisabled}
            disableHoverEffect={true}
            style={{ fontSize: '14px' }}
          >
            <MdAddCircleOutline size={20} /> Add More Filter
          </Button>

          <div
            className="col-1"
            style={{
              marginBottom: 1,
              marginTop: 50,
              fontWeight: 'medium',
              fontFamily: 'lg-smart, sans-serif',
            }}
          >
            Filters:
          </div>
          <div className="container-fluid" style={{ marginTop: 8 }}>
            <div className="row w-100">
              <div className="col" style={{ padding: 0, flex: '0 0 10%' }}>
                <Button
                  colorVariant="secondary"
                  variant="borderless"
                  disableHoverEffect={true}
                  onClick={resetFilters}
                  style={{
                    fontSize: 12,
                    marginTop: -3,
                    marginRight: 12,
                    marginLeft: 2,
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                  }}
                >
                  Clear All
                </Button>
              </div>
              <div className="col" style={{ marginTop: 5 }}>
                <Badges
                  items={filtersState
                    .filter(item => item.filter !== null)
                    .map(item => ({
                      key: item.filter.label,
                      value: item.value
                        ? item.value.map(v => v.label).join(', ')
                        : '',
                    }))}
                  onClose={handleBadgeClose}
                  variant="rounded"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* @ts-ignore - Production hotfix for kallos Modal.Body typing */}
    </Modal.Body>
  );
}
